import { useTranslation } from 'react-i18next'
import { Alert } from '@mui/material'
import { useField } from 'formik'

import { Month } from '@cbgms/api'
import { useEnumTranslation } from '@cbgms/base/enums/use-enum-translation'

export const TyreChangeCRMDateAlert = () => {
  const { te } = useEnumTranslation()
  const [summerMonthsInput] = useField<Month[]>('SummerChangeWarningMonths')
  const [winterMonthsInput] = useField<Month[]>('WinterChangeWarningMonths')
  const summerMonth = te('EnumMonth', findEarliestMonthFor('summer', summerMonthsInput.value))
  const winterMonth = te('EnumMonth', findEarliestMonthFor('winter', winterMonthsInput.value))

  const { t } = useTranslation()
  return <Alert severity='info'>{t('TyreChange.MonthsAlert', { summerMonth, winterMonth })}</Alert>
}

const monthsSortedForSummer = Object.values(Month)
const monthsSortedForWinter = [
  Month.July,
  Month.August,
  Month.September,
  Month.October,
  Month.November,
  Month.December,
  Month.January,
  Month.February,
  Month.March,
  Month.April,
  Month.May,
  Month.June
]

/**
 * This function tries to find the earliest month in a period (summer or winter)
 * for the provided array of months. For summer we start from january
 * and for winter we start from july. The provided months array doesn't
 * have to be sorted for the function to work.
 */
function findEarliestMonthFor(period: 'summer' | 'winter', months: Month[]) {
  const sortedMonths = period === 'summer' ? monthsSortedForSummer : monthsSortedForWinter

  const earliestMonthIndex = months.reduce((previousIndex, month) => {
    const index = sortedMonths.indexOf(month)

    if (previousIndex === 0) return index

    return index < previousIndex ? index : previousIndex
  }, 0)

  return sortedMonths[earliestMonthIndex]
}
